<template>
  <div>
    <task-stage-add-new
        :is-add-new-task-stage-sidebar-active.sync="isAddNewTaskStageSidebarActive"
        :id = "id"
        :data="taskstageData"
        @refetch-data="refetchData"
        v-if="ability.can('create','taskstages')"
    >

    </task-stage-add-new>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap">Add Task Stage</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refTaskStageListTable"
        class="position-relative"
        :items="fetchTaskStages"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(description)="data">
      <div v-html="data.item.description"></div>
    </template>

    <template #cell(complete_bit)="data">
        <feather-icon 
        v-if="data.item.complete_bit"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>

    <template #cell(demo)="data">
      <b-badge class="text-capitalize"
      :style="{background:data.item.background_color, color: data.item.font_color}"
      >
        {{ data.item.stage }}
      </b-badge>
    </template>

    <template #cell(action)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','taskstages')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTaskStages"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import taskstageStoreModule from "../taskstageStoreModule";
import useTaskStagesList from "./useTaskStagesList";
import TaskStageAddNew from "./TaskStageListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    TaskStageAddNew,
  },
  methods:{
      handleCreate(){
          this.id = 0
          this.resetTaskStageData()
          this.isAddNewTaskStageSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.taskstageData.id = item.id
        this.taskstageData.stage = item.stage
        this.taskstageData.description = item.description
        this.taskstageData.background_color = item.background_color
        this.taskstageData.font_color = item.font_color
        this.taskstageData.complete_bit = item.complete_bit
        this.isAddNewTaskStageSidebarActive = true
        
      }, resetTaskStageData(){
        this.taskstageData = {
            id: 0,
            stage: '',
            complete_bit: false,
            description: '#A5853D',
            background_color: '#FFFFFF',
        }
      }
  },
  data(){
    return {
        id:0,
        taskstageData:{},
    }  
  },
  setup() {
    const SETTING_TASK_STAGE_STORE_MODULE_NAME = "setting-taskstage";

    if (!store.hasModule(SETTING_TASK_STAGE_STORE_MODULE_NAME))
      store.registerModule(
        SETTING_TASK_STAGE_STORE_MODULE_NAME,
        taskstageStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(SETTING_TASK_STAGE_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_TASK_STAGE_STORE_MODULE_NAME);
    });

    const isAddNewTaskStageSidebarActive = ref(false);

    const {
      fetchTaskStages,
      tableColumns,
      perPage,
      currentPage,
      totalTaskStages,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTaskStageListTable,
      refetchData,
      ability,
    } = useTaskStagesList();

    return {
      //Sidebar
      isAddNewTaskStageSidebarActive,

      fetchTaskStages,
      tableColumns,
      perPage,
      currentPage,
      totalTaskStages,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTaskStageListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.badge {
  width:100%;
}
</style>